export enum OfficeToolsEventsEnum {
  BeforeDelete = 'BeforeDelete',
  AfterInsert = 'AfterInsert',
  AfterUpdate = 'AfterUpdate',
  BeforeUpdate = 'BeforeUpdate',
  BeforeInsert = 'BeforeInsert',
  BeforeTabChange = 'BeforeTabChange',
}

export type OfficeToolsEvents = `${OfficeToolsEventsEnum}`;
